export const formatCurrency = (amount: number, currency: string, cents: boolean = true, maximumFractionDigits?: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    ...(maximumFractionDigits !== undefined && { minimumFractionDigits: 0, maximumFractionDigits }),
  }).format(cents ? amount / 100 : amount);
};

// The displayed amount minus the currency symbol — what the copy buttons put on the clipboard, so a
// gateway search box or spreadsheet cell doesn't choke on the "$". Built from the same formatter as
// formatCurrency rather than a fixed 2-decimal rule, so zero-decimal currencies (JPY) still match
// what the user sees.
export const formatAmountWithoutCurrency = (amount: number, currency: string, cents: boolean = true) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  })
    .formatToParts(cents ? amount / 100 : amount)
    .filter((part) => part.type !== 'currency')
    .map((part) => part.value)
    .join('')
    .trim();
};

// Compact form for tight summary cards — e.g. $638K, $1.2M — so large prod amounts don't overflow.
export const formatCompactCurrency = (amount: number, currency: string, cents: boolean = true) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(cents ? amount / 100 : amount);
};

// Single dashboard-wide currency rule: full precision below $1M (e.g. $648,156), compact at or
// above it (e.g. $2.6M). Keeps every money figure formatted identically across cards/sections.
const COMPACT_THRESHOLD = 1_000_000;
export const formatCurrencyAdaptive = (amount: number, currency: string, cents: boolean = true) => {
  const dollars = cents ? amount / 100 : amount;
  return Math.abs(dollars) >= COMPACT_THRESHOLD
    ? formatCompactCurrency(amount, currency, cents)
    : formatCurrency(amount, currency, cents, 0);
};

